export default __webpack_public_path__ + "static/jamie-5356c6998d3762bc400e30d22974a24a.png";